import { LinkButton } from '@synoptic/ui-kit/link-button/link-button.js';
import { FC } from 'react';
import { PackageInStreamFragmentFragment } from '@/__generated__/graphql.ts';
import { ChoosePackageModal } from '@/components/streams/toggle-paid-stream-subscription/stream-included-in-package-modal.tsx';
import { includedInPackageLabel } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';

interface IncludedInPackageTagProps {
  packages: PackageInStreamFragmentFragment[];
  packageOnly?: boolean;
}

export const IncludedInPackageLabel: FC<IncludedInPackageTagProps> = ({
  packages,
  packageOnly,
}) => {
  const label = packageOnly
    ? 'Available only in a package!'
    : 'Included in the package';

  return (
    <ChoosePackageModal
      trigger={
        <LinkButton className={includedInPackageLabel} title={label}>
          <span className={includedInPackageLabel}>{label}</span>
        </LinkButton>
      }
      packages={packages}
      title={'Explore packages'}
      actionTitle={'Done'}
    />
  );
};
